import { Avatar, Chip, List, ListItem, ListItemAvatar, ListItemText, Popover, Tooltip } from "@mui/material";
import { useState } from "react";
import defaultProfile from "../../assets/default-profile.jpg";

const MAX_VISIBLE_ASSIGNEES = 3;

const AssigneesCompact = ({ assignments = [] }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const extra = assignments.slice(MAX_VISIBLE_ASSIGNEES);
  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const open = Boolean(anchorEl);

  return (
    <span className="d-flex align-items-center flex-wrap">
      {assignments.slice(0, MAX_VISIBLE_ASSIGNEES).map((a) => (
        <Tooltip key={a.assignmentId} title={`${a.lastName} ${a.firstName} assigned`}>
          <Chip
            size="small"
            className="border border-light mr-1 mb-1"
            avatar={
              <Avatar
                style={{ border: "1px solid #d1cbcb" }}
                alt={a.firstName}
                src={a.profileImage ? `data:image/jpeg;base64,${a.profileImage}` : defaultProfile}
              />
            }
            label={a.firstName}
            variant="outlined"
          />
        </Tooltip>
      ))}

      {extra.length > 0 && (
        <>
          <Chip
            size="small"
            className="mr-1 mb-1"
            color="default"
            variant="outlined"
            onClick={handleOpen}
            label={`+${extra.length} more`}
            clickable
          />
          <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
            PaperProps={{ sx: { maxHeight: 320, width: 300 } }}
          >
            <List dense sx={{ p: 0 }}>
              {extra.map((a) => (
                <ListItem key={a.assignmentId} sx={{ px: 1.5 }}>
                  <ListItemAvatar>
                    <Avatar
                      alt={a.firstName}
                      src={a.profileImage ? `data:image/jpeg;base64,${a.profileImage}` : defaultProfile}
                    />
                  </ListItemAvatar>
                  <ListItemText
                    primary={`${a.firstName} ${a.lastName}`}
                    secondary={a.email || a.position || ""}
                    primaryTypographyProps={{ noWrap: true }}
                    secondaryTypographyProps={{ noWrap: true }}
                  />
                </ListItem>
              ))}
            </List>
          </Popover>
        </>
      )}
    </span>
  );
};

export default AssigneesCompact;
